export const packages$ = state => state.package.packages;
export const publicPackages$ = state => state.package.publicPackages;
export const selectedPackage$ = state => state.package.selectedPackage;
export const packageLoading$ = state => state.package.isLoading;
export const packageError$ = state => state.package.error;
